import { Button } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import { AllScenarioTooltips } from "in_queue/components/common/AllScenarioTooltips";
import { useCurrentScenarioMetadata } from "in_queue/contexts/ScenarioPageContext";
import { useIsScenarioCreationEnabled } from "in_queue/hooks/useIsScenarioCreationEnabled";
import { useNavigate } from "react-router-dom";
import { useScenarioBuilderRoutes } from "../../ScenarioBuilder/useScenarioBuilderRoutes";

const DuplicateScenarioAction: React.FC = () => {
    const scenario = useCurrentScenarioMetadata();
    const navigate = useNavigate();
    const scenarioBuilderRoutes = useScenarioBuilderRoutes();
    const scenarioCreationEnabled = useIsScenarioCreationEnabled({
        stage: scenario.stage
    });

    return (
        <AllScenarioTooltips stage={scenario.stage}>
            <Button
                icon={IconNames.DUPLICATE}
                text="Duplicate scenario"
                onClick={() =>
                    navigate(
                        scenarioBuilderRoutes.duplicateHref(scenario.scenarioId)
                    )
                }
                disabled={!scenarioCreationEnabled}
            />
        </AllScenarioTooltips>
    );
};

export default DuplicateScenarioAction;
